module.exports = __webpack_public_path__ + "img/cable-tv.876a2c89.svg";